/**
 * Códigos de erro da consulta de auditoria (GET /audit-logs).
 */
export const AUDIT_ERRORS = {
  /** 400 — `cursor` que não foi gerado pela própria rota (adulterado ou de outro filtro). */
  INVALID_CURSOR: "ERR_AUDIT_INVALID_CURSOR",
  /** 400 — filtro com valor fora do catálogo ou data inválida. */
  INVALID_FILTER: "ERR_AUDIT_INVALID_FILTER"
} as const;

export type AuditErrorCode = (typeof AUDIT_ERRORS)[keyof typeof AUDIT_ERRORS];
